import type { paths } from "@api/schema";
import { type BoardVisit, withSurname } from "@board/boardVisit";
import type { SpriteTraits } from "@scribenote/brian-design-system";

/** Mirrors brian `modules/display/view_schemas.py` `ClinicBoardView`; change both together. */
type DisplayViewOut =
  paths["/display/me/view"]["get"]["responses"][200]["content"]["application/json"];
type ClinicBoardViewOut = Extract<DisplayViewOut, { kind: "clinic_board" }>;
type BoardVisitOut = ClinicBoardViewOut["visits"][number];

export interface DisplayBoardVisit extends BoardVisit {
  sprite: SpriteTraits | null;
}

export const toBoardVisit = (v: BoardVisitOut): DisplayBoardVisit => ({
  id: v.visit_uuid,
  patientId: v.patient_uuid,
  patientName: v.patient_name,
  name: withSurname(v.patient_name, v.surname),
  householdId: v.household_uuid,
  householdLabel: v.household_label,
  sprite: v.sprite,
  visitType: v.visit_type,
  flow: v.flow,
  position: v.position,
  progressAt: v.progress_at,
  roomId: v.room_uuid,
  roomName: v.room_name,
  dvmName: v.dvm_name,
  scheduledStart: v.scheduled_start,
  scheduledEnd: v.scheduled_end,
  createdAt: v.created_at,
  board: v.board,
});

export const toClinicBoardVisits = (
  view: ClinicBoardViewOut,
): DisplayBoardVisit[] => view.visits.map(toBoardVisit);
